export const TeamliveRequestsEmployerRoutes = {
    "/absence-requests?request_id&brand_id&user_id&active_tab&start_date&end_date": {
        "name": "schedule.absence-requests",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../employment-types/employment-types.module.js");
                }
            },
        ]
    },
    "/sickness-requests?request_id&brand_id&user_id&active_tab&start_date&end_date": {
        "name": "schedule.sickness-requests",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../employment-types/employment-types.module.js");
                }
            },
        ]
    }
};